import useScrollToHash from '@/hooks/use-scroll-to-hash'
import useTrackIndexDTFPage from '../hooks/useTrackIndexDTFPage'
import DistributeFees from './components/distribute-fees'
import RewardTokens from './components/index-settings-reward-tokens'
import BasicInfo from './components/index-settings-basic'
import FeesInfo from './components/index-settings-fees'
import GovernanceInfo from './components/index-settings-governance'
import GovernanceTokenInfo from './components/index-settings-governance-token'
import RolesInfo from './components/index-settings-roles'

const IndexDTFSettings = () => {
  useTrackIndexDTFPage('settings')
  useScrollToHash()

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[1.5fr_1fr] gap-2 lg:pr-2 lg:pb-4">
      <div className="flex flex-col gap-2">
        <BasicInfo />
        <GovernanceTokenInfo />
        <RewardTokens />
        <FeesInfo />
        <GovernanceInfo kind="trading" />
        <GovernanceInfo kind="owner"/>
        <GovernanceInfo kind="dao"/>
      </div>
      <div className="flex flex-col gap-2">
        <RolesInfo />
        <DistributeFees />
      </div>
    </div>
  )
}

export default IndexDTFSettings
